import { Button } from '@app/components/various/Button';
import { FocusTrap } from '@app/components/various/FocusTrap';
import { CancelSmall } from '@app/components/various/Icons';
import { handleEscapeKey } from '@app/utils/handleEscapeKey';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CSSTransition } from 'react-transition-group';

interface Props {
  title: React.ReactNode;
  isOpen: boolean;
  style?: React.CSSProperties;
  onClose?: () => void;
}

export const SizeDistributionPopover = React.forwardRef<HTMLDivElement, React.PropsWithChildren<Props>>(
  ({ title, isOpen, style, children, onClose }, ref) => {
    const { t } = useTranslation(['common']);

    return (
      <CSSTransition
        in={isOpen}
        timeout={150}
        unmountOnExit
        classNames={{
          enter: 'opacity-0 scale-90',
          enterActive: '!opacity-100 !scale-100 transition-[opacity,transform]',
          exit: 'opacity-100 scale-100',
          exitActive: '!opacity-0 !scale-90 transition-[opacity,transform]',
        }}
      >
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
        <div
          ref={ref}
          style={style}
          onKeyDown={handleEscapeKey(onClose)}
          className="z-popover max-w-md overflow-auto rounded-regular bg-white p-4 shadow-2"
        >
          <FocusTrap>
            <div className="mb-3 flex justify-between">
              <h3 data-sentry-mask className="line-clamp-2 heading-3">
                {title}
              </h3>
              <Button icon={CancelSmall} aria-label={t('common:close')} variant="ghost" color="secondary" size="medium" onClick={onClose} />
            </div>
            {children}
          </FocusTrap>
        </div>
      </CSSTransition>
    );
  },
);
